import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center justify-center" }

import useBasket from '@/b2c/basket/useBasket';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';


export default /*#__PURE__*/_defineComponent({
  __name: 'BasketLineItemRemove',
  props: {
    id: null
  },
  setup(__props: any) {




const { deleteItem } = useBasket();
const labels = useBlockLabels();


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      type: "button",
      class: "text-12 sm:text-14 text-dusty-grey c-magic-line c-magic-line--underline",
      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_unref(deleteItem)(__props.id)), ["prevent"]))
    }, _toDisplayString(_unref(labels).lineItemRemoveItem), 1)
  ]))
}
}

})